export default __webpack_public_path__ + "static/media/gasti.8b87c8af.jpeg";